import React from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import { DateTime } from 'luxon'

import CustomTooltip from './CustomTooltip'

export default function CustomLineChart({ chartData }) {
  const dateFormatter = (date) => {
    return DateTime.fromSeconds(date).toFormat('yyyy/LL/dd')
  }

  const cData = chartData
    ? chartData.map((d) => ({
        ...d,
        date: DateTime.fromISO(d.date).toSeconds(),
      }))
    : null

  return (
    <LineChart width={560} height={230} isAnimationActive={false} data={cData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis
        domain={[1388530800, 1648732148]}
        dataKey="date"
        tickFormatter={dateFormatter}
        name="Date"
        type="number"
        tick={{ fontSize: 12 }}
      />
      <YAxis
        domain={[-150, 150]}
        tick={{ fontSize: 12 }}
        label={{
          value: 'Displacement [mm]',
          fontSize: 12,
          angle: -90,
          position: 'center',
        }}
      />
      <Tooltip content={<CustomTooltip />} />
      <Line
        isAnimationActive={false}
        type="monotone"
        dataKey="displacement"
        dot={{ r: 1, stroke: '#2B6CB0',  }}
        stroke="none"
        activeDot={{ r: 2, stroke: '#2B6CB0' }}
      />
    </LineChart>
  )
}
